import { DboCloudProviderEnum } from '@cast/types-database-optimizer';
import { CspIcon } from '@cast/shared-csp-icons-ui';
import { ManualDbInstance } from 'assets/svg';
import { dboCloudproviderMap, dboInstanceProviderTooltips } from '../constants';
import { Stack, SxProps, Tooltip } from '@cast/design-system';

type InstanceIconProps = {
  provider: 'MANUAL' | DboCloudProviderEnum;
  size: number;
  sx?: SxProps;
  hideTooltip?: boolean;
};

export const InstanceIcon = ({
  size,
  provider,
  sx,
  hideTooltip,
}: InstanceIconProps) => {
  const icon =
    provider === 'MANUAL' ? (
      <ManualDbInstance width={size} height={size} />
    ) : (
      <CspIcon csp={dboCloudproviderMap[provider]} size={size} />
    );

  const wrapper = (
    <Stack alignItems="center" sx={sx}>
      {icon}
    </Stack>
  );

  if (hideTooltip) return wrapper;

  return (
    <Tooltip title={dboInstanceProviderTooltips[provider]} placement="top">
      {wrapper}
    </Tooltip>
  );
};
